import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { VacationDateRangeFilter, VacationPropertyFilter, VacationReportItem, VacationState } from './types';
import { AutoCompleteItemValue } from '../../components/shared/nextgen/selector/types';
import { Lx } from '../../i18n/consts';

interface State {
    filter: {
        dateRangeFilter: VacationDateRangeFilter;
        propertyFilter: VacationPropertyFilter;
    },
    data: Array<VacationReportItem>
}

export const initialVacationStates: AutoCompleteItemValue[] = [
    { id: VacationState.WaitApprove, name: Lx.Vacation.STATE_WAIT_APPROVE, originalId: VacationState.WaitApprove },
    { id: VacationState.Approved, name: Lx.Vacation.STATE_APPROVED, originalId: VacationState.Approved }
]

const initialState: State = {
    filter: {
        dateRangeFilter: {
            startDate: '',
            endDate: ''
        },
        propertyFilter: {
            selectedEmployees: [],
            selectedVacationStates: []
        }
    },
    data: []
}

const vacationReportSlice = createSlice({
    name: 'vacationsReport',
    initialState,
    reducers: {
        clearData: (state) => {
            state.data = []
        },
        setData: (state, action: PayloadAction<Array<VacationReportItem>>) => {
            state.data = action.payload
        },
        updateDateRangeFilter: (state, action: PayloadAction<VacationDateRangeFilter>) => {
            state.filter.dateRangeFilter = action.payload;
        },
        updatePropertyFilter: (state, action: PayloadAction<VacationPropertyFilter>) => {
            state.filter.propertyFilter = action.payload;
        }
    }
})

export const { updateDateRangeFilter, updatePropertyFilter, clearData, setData } = vacationReportSlice.actions;

export default vacationReportSlice.reducer;